import { getAccessToken } from "./auth"
import { encryptAadhaarNumber } from "./aadhaarEncryption";
import { encryptSMSRequest, decryptSMSResponse } from "./smsEncryption";
import { decryptEmail, encryptEmail } from "./emailEncryption";
// import { getCsrfToken } from "../utils/liferay";

async function decryptAndParseEmailPayload(data) {
  if (!data?.email || !data?.emailIv) {
    return data;
  }

  const decryptedEmailPayload = await decryptEmail(data.email, data.emailIv);

  try {
    const parsedPayload =
      typeof decryptedEmailPayload === "string"
        ? JSON.parse(decryptedEmailPayload)
        : decryptedEmailPayload;

    return {
      ...data,
      ...parsedPayload,
      email: parsedPayload?.email ?? data.email,
    };
  } catch (_error) {
    return {
      ...data,
      email: decryptedEmailPayload,
    };
  }
}
export async function sendAadhaarOTP(aadhaarNumber) {
  try {
    const token = await getAccessToken();
    const encryptedAadhaarPayload = await encryptAadhaarNumber(aadhaarNumber);
    const enc = await encryptSMSRequest(encryptedAadhaarPayload);
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/send-aadhaar-otp",
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),
        credentials: "include"
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Failed to send Aadhaar OTP. Status: ${response.status}, Response: ${errorText}`
      );
    }

    const data = await response.json();
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;
  } catch (error) {
    console.error("Error sending Aadhaar OTP:", error);
    return { status: "400", error: "Failed to send Aadhaar OTP. Please try again.", success: false }
  }
}

export async function verifyAadhaarOTP(aadhaarNumber, id, otp, key) {
  try {
    const token = await getAccessToken();
    const encryptedAadhaarPayload = await encryptAadhaarNumber(aadhaarNumber);
    const plaintextPayload = {
      ...encryptedAadhaarPayload,
      id: id,
      aadhaarOTP: otp,
      key: key
    };
    
    const enc = await encryptSMSRequest(plaintextPayload);
    
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/verify-aadhaar-otp",
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Failed to verify OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    return {
      statusCode: 400,
      message: "Verification failed. Please try again.",
      error: "Failed to verify OTP",
      success: false
    };
  }
}


export async function sendEmailOTP(email) {
  try {
    console.log("sendEmailOTP:::::", email);
    const normalizedEmail = `${email || ""}`.trim();
    if (!normalizedEmail) {
      return {
        statusCode: 400,
        error: "Email is required",
      };
    }
    const token = await getAccessToken();
    console.log("token:::::", token);

    const enc = await encryptSMSRequest({ email: normalizedEmail });
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/send-email-otp",
      {
        method: "POST",
        headers: {
          "Authorization": "Basic " + btoa("prabhudasu:root"),
          //"Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response:", errorText);
      throw new Error(
        `Failed to send Email OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;

  } catch (error) {
    console.error("Error sending Email OTP:", error);
    return {
      status: 400,
      message: "OTP sending failed. Please try again.",
      success: false,
      error: error.message || "An unexpected error occurred while sending OTP."
    };
  }
}

// In your api/verify-otp.js or similar file
export async function verifyEmailOTP(email, id, otp, key) {
  try {
    console.log("Verifying OTP:", { email, id, otp, key });
    const token = await getAccessToken();
    console.log("token:::::", token);
    const normalizedEmail = `${email || ""}`.trim();
    const normalizedOtp = `${otp || ""}`.trim();
    
    const enc = await encryptSMSRequest({
      email: normalizedEmail,
      id,
      otp: normalizedOtp,
      key,
    });
    const requestBody = JSON.stringify({
      encryptedPayload: enc.encryptedPayload,
      signature: enc.signature,
      iv: enc.iv
    });
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/verify-otp",
      {
        method: "POST",
        headers: {
          "Authorization": "Basic " + btoa("prabhudasu:root"),
         // "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: requestBody,
      }
    );

    console.log("Verify OTP Response Status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Verify OTP Error:", errorText);
      throw new Error(
        `Failed to verify OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    let normalizedData = data;
    if (data.encryptedResponse && data.iv) {
      normalizedData = await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    const requestedEmail = normalizedEmail.toLowerCase();
    const responseEmail = String(normalizedData?.email || "").trim().toLowerCase();

    if (!requestedEmail || !responseEmail || requestedEmail !== responseEmail) {
      return {
        statusCode: 400,
        error: "Email mismatch. Verification failed.",
        success: false,
        matched: false,
      };
    }

    console.log("Verify OTP Success Response:", normalizedData);
    return normalizedData;

  } catch (error) {
    console.error("Error verifying OTP:", error, error.message);
    return {
      statusCode: 400,
      message: "Verification failed. Please try again.",
      success: false,
      error: error.message || "An unexpected error occurred during OTP verification."
    };
  }
}

export async function checkVerified(verification, setSubmissionModal, verifiedFields, fieldName, errorFieldName, payloadData, verifyingField) {
  try {
    // Check if email and aadhaar fields exist in verifiedFields
    const hasField = fieldName && fieldName in verifiedFields;
    // Determine verification status from multiple sources
    const isVerified = (verification?.verified === true && payloadData === verifyingField) ||
      (hasField && verifiedFields[fieldName] === true);
    // If both are verified, return true
    if (isVerified) {
      return true;
    }
    // Check if we should even verify these fields (based on whether they exist in verifiedFields)
    const shouldCheck = hasField || verification !== undefined;
    // Only show errors for fields that actually need verification
    const missingVerifications = [];

    if (shouldCheck) {
      missingVerifications.push(errorFieldName || "");
    }

    // If there are missing verifications, show error
    if (missingVerifications.length > 0) {
      let message = "";
      message = `Please verify your ${missingVerifications[0]} before proceeding.`;
      // Show modal with error
      setSubmissionModal({
        show: true,
        title: "Verification Required",
        message: message,
        variant: "primary",
        isVerified: true
      });

      return false;
    }
    return true;

  } catch (error) {
    console.error("Error in check for Verified field:", error);

    // Show error modal
    setSubmissionModal({
      show: true,
      title: "Verification Error",
      message: "Unable to check verification status. Please try again.",
      variant: "primary"
    });

    return false;
  }
}

async function verifyOtrNumber(otrNumber, aadhaarnumber) {
  try {
    const token = await getAccessToken();
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/validate/otr",
      {
        method: "POST",
        // headers: {
        //   "Accept": "application/json",
        //   "Content-Type": "application/json",
        //   "x-csrf-token": window.Liferay?.authToken || ""
        // },
        // credentials: "include",
        headers: {
          //"Authorization": "Basic " + btoa("prabhudasu:root"),
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          otrNo: otrNumber,
          aadhaar: aadhaarnumber
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        status: "FAILURE",
        message: data?.error || "Something went wrong"
      };
    }

    console.log("OTR Validation Response:", data);
    return {
      status: data.status,
      message: data?.error || "Validation Successful"
    };

  } catch (error) {
    console.error("Error verifying OTR number:", error);
    return {
      status: "FAILURE",
      message: "Server error occurred"
    };
  }
}


export async function sendMobileOTP(mobileNumber) {
  try {
    console.log("sendEmailOTP:::::", mobileNumber);
    const token = await getAccessToken();
    console.log("token:::::", token);

    const enc = await encryptSMSRequest({ mobileNumber: Number(mobileNumber) });
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/send-sms-otp",
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),

      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response:", errorText);
      throw new Error(
        `Failed to send Email OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    console.log("sendEmailOTP Success Response:", data);
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;

  } catch (error) {
    console.error("Error sending Email OTP:", error);
    // Return a more descriptive error object
    return {
      status: 400,
      message: "OTP sending failed. Please try again.",
      success: false,
      error: error.message || "An unexpected error occurred while sending OTP."
    };
  }
}



export async function verifyMobileOTP(payload) {
  try {
    console.log("Verifying OTP:", { payload });
    const token = await getAccessToken();
    console.log("token:::::", token);
    const enc = await encryptSMSRequest({
      ...payload,
      mobileNumber: Number(payload.mobileNumber)
    });
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/verify-sms-otp",
      {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),
      }
    );

    console.log("Verify OTP Response Status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Verify OTP Error:", errorText);
      throw new Error(
        `Failed to verify OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    console.log("Verify OTP Success Response:", data);
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;

  } catch (error) {
    console.error("Error verifying OTP:", error, error.message);
    return {
      statusCode: 400,
      message: "Verification failed. Please try again.",
      success: false,
      error: error.message || "An unexpected error occurred during OTP verification."
    };
  }
}
